import React from 'react'
import { PersistedQuestion, QuestionInputProps } from '../questionTypes'
import { FreeFormQuestion } from './questions/FreeFormQuestion'
import { RatingQuestion } from './questions/RatingQuestion'
import { MultipleChoiceQuestion } from './questions/MultipleChoiceQuestion'
import { YesNoQuestion } from './questions/YesNoQuestion'
import { NpsQuestion } from './questions/NpsQuestion'
import { DatePickerQuestion } from './questions/DatePickerQuestion'
import { DollarValueQuestion } from './questions/DollarValueQuestion'

interface QuestionRendererProps {
  question: PersistedQuestion
  // The display number for this question (1-based). The caller computes it — the
  // component just renders it, no index math here.
  questionNumber: number
  value: string
  onChange: (value: string) => void
  // Non-interactive preview mode (used by the builder-track editor). Passed through
  // to the input child; the dispatcher itself is unaffected.
  readOnly?: boolean
}

// Dispatcher for the RESPONSE track: maps a question_type to its input child.
// Pure routing — keep it thin. (Builder track lives under surveys/builder/.)
const QUESTION_INPUTS: Record<PersistedQuestion['question_type'], React.FC<QuestionInputProps>> = {
  free_form: FreeFormQuestion,
  rating: RatingQuestion,
  multiple_choice: MultipleChoiceQuestion,
  yes_no: YesNoQuestion,
  nps: NpsQuestion,
  date_picker: DatePickerQuestion,
  dollar_value: DollarValueQuestion
}

export const QuestionRenderer: React.FC<QuestionRendererProps> = ({ question, questionNumber, value, onChange, readOnly = false }) => {
  const QuestionInput = QUESTION_INPUTS[question.question_type]

  return (
    <div className={['survey-response-question', value !== '' && 'is-answered'].filter(Boolean).join(' ')}>
      <div className='survey-response-question__number'>{questionNumber}</div>
      <div className='survey-response-question__content'>
        <label className='survey-response-question__label' htmlFor={`question-${question.id}`}>
          {question.prompt}
          {question.required && <span className='survey-response-question__required'>Required</span>}
        </label>
        {QuestionInput != null && (
          <QuestionInput question={question} value={value} onChange={onChange} readOnly={readOnly} />
        )}
      </div>
    </div>
  )
}
